/* Progressive enhancement: all instructions remain readable without JavaScript. */
(() => {
  if (customElements.get('ch-use-guide')) return;
  customElements.define('ch-use-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.buttons = [...this.querySelectorAll('[data-ug-step]')];
      this.scenes = [...this.querySelectorAll('[data-ug-scene]')];
      this.panels = [...this.querySelectorAll('.ug__description')];
      if (!this.buttons.length || this.buttons.length !== this.scenes.length) return;
      this.toggleAttribute('data-many', this.buttons.length > 4);
      this.buttons.forEach((button, i) => {
        button.addEventListener('click', () => this.select(i), options);
        button.addEventListener('keydown', event => {
          const keys = { ArrowDown: (i + 1) % this.buttons.length, ArrowRight: (i + 1) % this.buttons.length, ArrowUp: (i + this.buttons.length - 1) % this.buttons.length, ArrowLeft: (i + this.buttons.length - 1) % this.buttons.length, Home: 0, End: this.buttons.length - 1 };
          if (keys[event.key] !== undefined) { event.preventDefault(); this.select(keys[event.key], true); }
        }, options);
      });
      this.querySelectorAll('[data-ug-next]').forEach(button => button.addEventListener('click', () => this.select(Number(button.dataset.ugNext), true), options));
      document.addEventListener('shopify:block:select', event => {
        const i = [...this.querySelectorAll('[data-ug-block]')].findIndex(block => block.dataset.ugBlock === event.detail?.blockId);
        if (i >= 0) this.select(i);
      }, options);
      this.setAttribute('data-ready', '');
      this.select(0, false, false);
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    select(index, focus = false, animate = true) {
      if (!this.buttons[index]) return;
      this.buttons.forEach((button, i) => {
        const active = i === index;
        button.setAttribute('aria-expanded', String(active));
        button.closest('.ug__step').classList.toggle('is-active', active);
        this.panels[i].hidden = !active;
        this.scenes[i].hidden = !active;
        this.scenes[i].classList.toggle('is-entering', active && animate);
      });
      if (focus) this.buttons[index].focus({ preventScroll: true });
    }
  });
})();
